//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/linkedin/followers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/linkedin/followerEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/linkedin/followersEvolutionPercentage';

//charts
import { followersGrowthHistoryConfig } from '@/lib/analytics/charts/linkedin/followersGrowthHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/linkedin/gainedLostFollowers';
import { followersCountriesConfig } from '@/lib/analytics/charts/linkedin/followersCountriesConfig';

export const CommunityLinkedin = [
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,
    followersGrowthHistoryConfig,
    gainedLostFollowersConfig,
    followersCountriesConfig
];

export const requestLinkedinParams = [
    // LinkedinAccountMetrics
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'follower_growth_history',
        'gained_lost_followers_history'
    ],
    // LinkedinCommunity
    ['followers_countries']
];
